import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

import { App } from "App";
import { isDev } from "common/utilities/environment";
import "fonts.css";
import internetExplorerFallback from "internetExplorerFallback.html?raw";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  debug: false,
  enabled: !isDev,
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  // This is a list of URLs that will be used to propagate traces to servers via `sentry-trace` header
  // See docs here: https://develop.sentry.dev/sdk/telemetry/traces/
  tracePropagationTargets: ["localhost", /^https:\/\/intelligence-api-(\w+)\.ent\.sdy\.ai$/],
});

const container = document.getElementById("root");
if (container === null) throw new Error('No element has ID "root".');

if (/msie|trident/i.test(navigator.userAgent)) container.innerHTML = internetExplorerFallback;
else createRoot(container).render(<App />);
